// 个人中心

import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import { getServerTime } from '../../../utils/wz.v2'

const state = {
    _now: getServerTime()
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
